import { AdvisorThemeDark } from './AdvisorDark';
import { AdvisorThemeLight } from './AdvisorLight';
import { EtoroThemeLight } from './EtoroLight';
import { GenistarThemeLight } from './GenistarLight';
import { MoneyfarmTheme } from './Moneyfarm';
import { Moneyfarm2023ThemeDark } from './Moneyfarm2023Dark';
import { Moneyfarm2023ThemeLight } from './Moneyfarm2023Light';
import { MoneyfarmThemeDark } from './MoneyfarmDark';
import { MoneyfarmThemeLight } from './MoneyfarmLight';
export var Themes = {
  mf: MoneyfarmTheme,
  mfLight: MoneyfarmThemeLight,
  mfDark: MoneyfarmThemeDark,
  mf2023Light: Moneyfarm2023ThemeLight,
  mf2023Dark: Moneyfarm2023ThemeDark,
  adLight: AdvisorThemeLight,
  adDark: AdvisorThemeDark,
  etoroLight: EtoroThemeLight,
  genistarLight: GenistarThemeLight
};